import { Injectable } from '@angular/core';
import { EligibilityAssessment } from '../../../../models/order.model';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderDetailsStateService {
  private readonly _eligibilityAssessment$ =
    new ReplaySubject<EligibilityAssessment | null>(1);

  readonly eligibilityAssessmentChanged$ =
    this._eligibilityAssessment$.asObservable();

  publishEligibilityAssessment(value: EligibilityAssessment | null): void {
    this._eligibilityAssessment$.next(value);
  }
}
